const VNDvndpayOptions = [
    {
        value: "115",
        label: "Techcombank",
    },
    {
        value: "116",
        label: "Sacombank",
    },
    {
        value: "117",
        label: "Vietcombank",
    },
    {
        value: "118",
        label: "Asia Commercial Bank",
    },
    {
        value: "119",
        label: "DongA Bank",
    },
    {
        value: "120",
        label: "Vietin Bank",
    },
    {
        value: "121",
        label: "Bank for Investment and Development of Vietnam",
    },
    {
        value: "122",
        label: "Eximbank Vietnam",
    },
    {
        value: "127",
        label: "CIMB",
    },
    {
        value: "128",
        label: "Vietnam Prosperity Joint-Stock Commercial Bank",
    },
    {
        value: "129",
        label: "Military Commercial Joint Stock Bank",
    },
    {
        value: "130",
        label: "Tien Phong Commercial",
    },
    {
        value: "131",
        label: "AGRI BANK",
    },
    {
        value: "132",
        label: "Lien Viet Post Joint Stock Commercial Bank",
    },
    {
        value: "133",
        label: "Saigon – Hanoi Commercial Joint Stock Bank",
    },
    {
        value: "134",
        label: "Vietnam Public Joint-stock Commercial Bank",
    },
    {
        value: "135",
        label: "SAIGON BANK",
    },
    {
        value: "136",
        label: "Southeast Asia Commercial Joint Stock Bank",
    },
    {
        value: "137",
        label: "An Binh Commercial Join Stock Bank",
    },
    {
        value: "138",
        label: "Bac A Bank",
    },
    {
        value: "139",
        label: "Viet Capital Bank",
    },
    {
        value: "140",
        label: "Vietnam Maritime Commercial Joint Stock Bank",
    },
    {
        value: "141",
        label: "Kien Long Commercial Joint Stock Bank",
    },
    {
        value: "142",
        label: "Nam A Commercial Joint Stock Bank",
    },
    {
        value: "143",
        label: "National Citizen Commercial Joint Stock Bank",
    },
    {
        value: "144",
        label: "HD Bank",
    },
    {
        value: "145",
        label: "Orient Commercial Joint Stock Bank",
    },
    {
        value: "146",
        label: "Vietnam International Commercial Joint Stock Bank",
    },
    {
        value: "147",
        label: "Sai Gon Joint Stock Commercial Bank",
    },
    {
        value: "148",
        label: "Saigon Bank for Industry and Trade",
    },
    {
        value: "149",
        label: "VietABank",
    },
    {
        value: "150",
        label: "BAOVIET Bank",
    },
    {
        value: "151",
        label: "Vietnam Thuong Tin Commercial Joint Stock Bank",
    },
    {
        value: "152",
        label: "Petrolimex Group Commercial Joint Stock Bank",
    },
    {
        value: "157",
        label: "Ocean Bank",
    },
    {
        value: "158",
        label: "GP Bank",
    },
    {
        value: "159",
        label: "Shinhan Bank",
    },
    {
        value: "165",
        label: "HSBC BANK",
    },
    {
        value: "166",
        label: "Vietnam-Russia Joint Venture Bank",
    },
    {
        value: "167",
        label: "Vietnam Development Bank",
    },
    {
        value: "500",
        label: "USDT ERC",
    },
    {
        value: "501",
        label: "USDT TRC20",
    },
    {
        value: "1000",
        label: "Others Bank",
    },
    {
        value: "2000",
        label: "Cross Bank",
    },
];

export default VNDvndpayOptions;
